<template>
    <div>
        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <h2 style="font-size: 40px; font-weight: 700; line-height: 48px;" class="mb-0 mt-5 d-flex align-items-center">Notices <i @click="modals.help = true" class="fa fa-question-circle" style="cursor: pointer; margin-left: 20px; opacity: 0.8; font-size: 25px;"></i></h2>
            </div>
            <div class="col-sm-12 col-md-12 col-lg-12 pt-4">
                <p>Add, edit or remove notices shown to your agencies and clients here.</p>
            </div>
        </div>
        <div class="pt-3 pb-3">&nbsp;</div>

        <div class="row">
            <div class="col-sm-12 col-md-12 col-lg-12">
                <card>
                    <div class="row">
                        <div class="col-12 notice-list__toolbar">
                            <div class="notice-list__filters">
                                <base-input class="notice-list__search">
                                    <el-input
                                        type="text"
                                        class="search-input input__notice__list"
                                        clearable
                                        prefix-icon="el-icon-search"
                                        placeholder="Search Notice"
                                        v-model="searchQuery"
                                        @input="onSearchInput"
                                        @keyup.native.enter="searchNow"
                                        @clear="searchNow"
                                    >
                                    </el-input>
                                </base-input>
                            </div>
                            <div class="notice-list__actions">
                                <!-- pola yang sama dengan tombol Filters di Client Management -->
                                <el-dropdown ref="filterDropdown" trigger="click" :hide-on-click="false" @visible-change="onFilterVisibleChange">
                                    <span>
                                        <base-button size="sm" class="button__add__notice__list" style="height:40px;">
                                            <i class="fa-solid fa-filter"></i> Filters<span v-if="activeFilterCount"> ({{ activeFilterCount }})</span>
                                        </base-button>
                                    </span>
                                    <el-dropdown-menu slot="dropdown" class="notice-list__filter-menu" @click.native.stop>
                                        <div class="ml-4 mr-4">
                                            <el-collapse v-for="group in filterGroups" :key="group.key" :value="group.title" style="border: none;">
                                                <el-collapse-item :title="group.title" :name="group.title">
                                                    <el-checkbox-group v-model="filterDraft[group.key]" class="notice-list__filter-options">
                                                        <el-checkbox v-for="option in group.options" :key="option.value" :label="option.value">{{ option.label }}</el-checkbox>
                                                    </el-checkbox-group>
                                                </el-collapse-item>
                                            </el-collapse>
                                        </div>
                                        <div class="d-flex justify-content-between align-items-center ml-4 mr-4 mt-4">
                                            <a href="#" class="notice-list__filter-reset" @click.prevent="resetFilterDraft">Reset</a>
                                            <base-button :simple="true" size="sm" @click="applyFilters">Save</base-button>
                                        </div>
                                    </el-dropdown-menu>
                                </el-dropdown>
                                <base-button size="sm" class="button__add__notice__list" style="height:40px;" @click="openForm(null)">
                                    <i class="fas fa-plus-circle"></i> Add Notice
                                </base-button>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-12 tab-table">
                            <el-table :data="tableData" @sort-change="onSortChange">
                                <template #empty>
                                    <template v-if="loading"><i class="fas fa-spinner fa-pulse fa-2x d-block"></i>Loading data...</template>
                                    <template v-else>No Data</template>
                                </template>
                                <el-table-column min-width="220" prop="title" sortable="custom" label="Title">
                                    <div slot-scope="props" class="notice-list__title">{{ props.row.title }}</div>
                                </el-table-column>
                                <el-table-column min-width="100" align="center" label="Type">
                                    <div slot-scope="props">
                                        <span class="notice-type-badge" :class="'notice-type-badge--' + props.row.type">{{ typeLabel(props.row.type) }}</span>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="160" label="Target">
                                    <div slot-scope="props">
                                        {{ targetLabel(props.row) }}<span v-if="props.row.is_global" class="notice-global-badge">Global</span>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="110" align="center" label="Status">
                                    <div slot-scope="props">
                                        <span class="notice-status-badge" :class="'notice-status-badge--' + props.row.status">{{ statusLabel(props.row.status) }}</span>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="start_date" sortable="custom" label="Start">
                                    <div slot-scope="props">{{ formatDate(props.row.start_date) }}</div>
                                </el-table-column>
                                <el-table-column min-width="130" label="End">
                                    <div slot-scope="props">{{ props.row.end_date ? formatDate(props.row.end_date) : 'Until dismissed' }}</div>
                                </el-table-column>
                                <el-table-column min-width="110" align="center" label="Dismissed">
                                    <div slot-scope="props">
                                        <el-popover trigger="hover" content="See who has and has not dismissed" :open-delay="300" placement="top">
                                            <a slot="reference" href="#" class="notice-list__dismissed" @click.prevent="openReport(props.row)">{{ props.row.dismissed_count }} / {{ props.row.target_total }}</a>
                                        </el-popover>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="90" align="center" label="Active">
                                    <div slot-scope="props">
                                        <el-switch
                                            :value="props.row.is_active"
                                            :disabled="togglingId === props.row.id"
                                            @change="toggleActive(props.row, $event)"
                                        ></el-switch>
                                    </div>
                                </el-table-column>
                                <el-table-column min-width="150" label="Created by">
                                    <div slot-scope="props">{{ props.row.created_by_name || '-' }}</div>
                                </el-table-column>
                                <el-table-column min-width="120" prop="created_at" sortable="custom" align="center" label="Created">
                                    <div slot-scope="props">{{ props.row.created_at }}</div>
                                </el-table-column>
                                <el-table-column min-width="110" align="center" label="Actions">
                                    <div slot-scope="props" class="d-flex flex-row align-items-center justify-content-center">
                                        <!-- el-popover hover seperti ikon aksi Client Management; el-tooltip di versi Element ini melempar error innerHTML -->
                                        <el-popover trigger="hover" content="Edit" :open-delay="300" placement="top">
                                            <base-button slot="reference" @click="openForm(props.row)" class="edit btn-link" type="neutral" size="sm" icon>
                                                <i class="fa-solid fa-pen-to-square" style="color:gray"></i>
                                            </base-button>
                                        </el-popover>
                                        <el-popover trigger="hover" content="Delete" :open-delay="300" placement="top">
                                            <i slot="reference" class="fa-solid fa-circle-x notice-list__delete" @click="confirmDelete(props.row)"></i>
                                        </el-popover>
                                    </div>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>

                    <template slot="footer">
                        <div class="tab-footer pull-right">
                            <div class="pt-3">
                                <p class="card-category">
                                    Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries
                                </p>
                            </div>
                            <base-pagination
                                class="pagination-no-border pt-4"
                                v-model="pagination.currentPage"
                                :per-page="pagination.perPage"
                                :total="pagination.total"
                                @input="changePage"
                            >
                            </base-pagination>
                        </div>
                    </template>
                </card>
            </div>
        </div>

        <modal :show.sync="modals.help" headerClasses="">
            <div slot="header"><h4 class="title title-up">Notices</h4></div>
            <div class="text-dark notice-list__help">
                <p>Notices appear in the bell at the top right for the agencies and/or clients under your company.</p>
                <ul>
                    <li><strong>Info</strong> and <strong>Warning</strong> are shown in the bell only.</li>
                    <li><strong>Critical</strong> is also shown as a popup until users dismiss it. "Remind me later" hides the popup for 24 hours.</li>
                    <li>Dates follow America/Chicago time. Leave the end date empty to show the notice until users dismiss it.</li>
                    <li><strong>Dismissed</strong> shows how many target users have dismissed a notice. Click it to see who has and who has not.</li>
                </ul>
            </div>
        </modal>

        <notice-form-modal :visible.sync="form.visible" :notice="form.notice" @saved="onSaved"></notice-form-modal>
        <notice-report-modal :visible.sync="report.visible" :notice="report.notice"></notice-report-modal>
    </div>
</template>

<script>
import { Table, TableColumn, Switch, Dropdown, DropdownMenu, Collapse, CollapseItem, Checkbox, CheckboxGroup } from 'element-ui';
import { BasePagination, Modal } from 'src/components';
import swal from 'sweetalert2';
import NoticeFormModal from './components/NoticeFormModal.vue';
import NoticeReportModal from './components/NoticeReportModal.vue';
import { NOTICE_STATUSES, NOTICE_TYPES, formatNoticeDate, noticeTypeLabel, noticeStatusLabel } from '@/helpers/notices';
import '@/components/Notices/notices.css';

const SEARCH_DEBOUNCE_MS = 500;

function emptyFilters() {
    return { status: [], type: [], target: [] };
}

/**
 * TASK-EMM-1020: halaman kelola notice untuk root dan admin root (Keputusan 12).
 * Search, filter, sort, dan pagination diproses di backend.
 */
export default {
    name: 'Notices',
    components: {
        Modal,
        BasePagination,
        NoticeFormModal,
        NoticeReportModal,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Switch.name]: Switch,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Checkbox.name]: Checkbox,
        [CheckboxGroup.name]: CheckboxGroup,
    },
    data() {
        return {
            tableData: [],
            loading: false,
            requestId: 0,
            searchQuery: '',
            searchTimer: null,
            // filters = yang sedang dipakai tabel, filterDraft = centangan di dropdown sebelum Save
            filters: emptyFilters(),
            filterDraft: emptyFilters(),
            sortBy: '',
            sortOrder: '',
            togglingId: null,
            pagination: {
                perPage: 10,
                currentPage: 1,
                total: 0,
                from: 0,
                to: 0,
            },
            modals: {
                help: false,
            },
            form: {
                visible: false,
                notice: null,
            },
            report: {
                visible: false,
                notice: null,
            },
        };
    },
    computed: {
        filterGroups() {
            return [
                { key: 'status', title: 'Status', options: NOTICE_STATUSES },
                { key: 'type', title: 'Type', options: NOTICE_TYPES },
                { key: 'target', title: 'Target', options: [{ value: 'agency', label: 'Agency' }, { value: 'client', label: 'Client' }] },
            ];
        },
        activeFilterCount() {
            return this.filters.status.length + this.filters.type.length + this.filters.target.length;
        },
    },
    watch: {
        // laporan selalu mengambil data baru, jadi angka x / y di tabel ikut diperbarui saat modal ditutup
        'report.visible'(value) {
            if (!value) {
                this.fetchNotices({ silent: true });
            }
        },
    },
    methods: {
        typeLabel(type) {
            return noticeTypeLabel(type);
        },
        statusLabel(status) {
            return noticeStatusLabel(status);
        },
        formatDate(value) {
            return formatNoticeDate(value);
        },
        targetLabel(row) {
            const targets = [];
            if (row.target_agency) targets.push('Agency');
            if (row.target_client) targets.push('Client');
            return targets.join(', ');
        },
        onSearchInput() {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(this.searchNow, SEARCH_DEBOUNCE_MS);
        },
        // dropdown dibuka: centangan disamakan lagi dengan filter yang dipakai (perubahan tanpa Save dibuang)
        onFilterVisibleChange(visible) {
            if (visible) {
                this.filterDraft = {
                    status: this.filters.status.slice(),
                    type: this.filters.type.slice(),
                    target: this.filters.target.slice(),
                };
            }
        },
        resetFilterDraft() {
            this.filterDraft = emptyFilters();
        },
        applyFilters() {
            this.filters = {
                status: this.filterDraft.status.slice(),
                type: this.filterDraft.type.slice(),
                target: this.filterDraft.target.slice(),
            };
            if (this.$refs.filterDropdown) {
                this.$refs.filterDropdown.hide();
            }
            this.searchNow();
        },
        searchNow() {
            clearTimeout(this.searchTimer);
            this.pagination.currentPage = 1;
            this.fetchNotices();
        },
        onSortChange({ prop, order }) {
            this.sortBy = order ? prop : '';
            this.sortOrder = order || '';
            this.pagination.currentPage = 1;
            this.fetchNotices();
        },
        changePage() {
            this.fetchNotices();
        },
        // silent: tabel lama tetap tampil tanpa "Loading data...", dan gagal diabaikan tanpa toast
        async fetchNotices({ silent = false } = {}) {
            // respons lama (misalnya saat search masih diketik) diabaikan
            const requestId = ++this.requestId;
            if (!silent) {
                this.loading = true;
                this.tableData = [];
            }
            try {
                const response = await this.$store.dispatch('fetchNotices', {
                    page: this.pagination.currentPage,
                    search: this.searchQuery,
                    status: this.filters.status.join(','),
                    type: this.filters.type.join(','),
                    target: this.filters.target.join(','),
                    sort_by: this.sortBy,
                    sort_order: this.sortOrder,
                });
                if (requestId !== this.requestId) return;
                this.tableData = response.data;
                this.pagination.currentPage = response.pagination.current_page;
                this.pagination.total = response.pagination.total;
                this.pagination.from = response.pagination.from;
                this.pagination.to = response.pagination.to;
            } catch (message) {
                if (requestId !== this.requestId || silent) return;
                this.pagination.total = 0;
                this.pagination.from = 0;
                this.pagination.to = 0;
                this.$notify({ type: 'danger', message: message || 'Failed to fetch notices', icon: 'fas fa-bug' });
            } finally {
                if (requestId === this.requestId) {
                    this.loading = false;
                }
            }
        },
        async toggleActive(row, value) {
            const previous = row.is_active;
            row.is_active = value;
            this.togglingId = row.id;
            try {
                const data = await this.$store.dispatch('toggleNoticeActive', { id: row.id, isActive: value });
                row.status = data.status;
                this.$notify({
                    type: 'success',
                    message: value ? 'Notice has been activated' : 'Notice has been deactivated',
                    icon: 'far fa-save',
                });
            } catch (message) {
                row.is_active = previous;
                this.$notify({ type: 'danger', message: message || 'Failed to update notice', icon: 'fas fa-bug' });
            } finally {
                this.togglingId = null;
            }
        },
        confirmDelete(row) {
            swal.fire({
                title: 'Delete this notice?',
                text: 'It will be removed for all agencies and clients.',
                icon: '',
                showCancelButton: true,
                customClass: {
                    confirmButton: 'btn btn-fill mr-3',
                    cancelButton: 'btn btn-danger btn-fill',
                },
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false,
            }).then(async result => {
                if (!result.value) return;
                try {
                    await this.$store.dispatch('deleteNotice', row.id);
                    this.$notify({ type: 'success', message: 'Notice has been deleted', icon: 'far fa-save' });
                    if (this.tableData.length === 1 && this.pagination.currentPage > 1) {
                        this.pagination.currentPage -= 1;
                    }
                    this.fetchNotices();
                } catch (message) {
                    this.$notify({ type: 'danger', message: message || 'Failed to delete notice', icon: 'fas fa-bug' });
                }
            });
        },
        openForm(row) {
            this.form.notice = row;
            this.form.visible = true;
        },
        onSaved({ created }) {
            // notice baru selalu di atas pada urutan default, jadi kembali ke halaman 1
            if (created) {
                this.pagination.currentPage = 1;
            }
            this.fetchNotices();
        },
        openReport(row) {
            this.report.notice = row;
            this.report.visible = true;
        },
    },
    mounted() {
        this.fetchNotices();
    },
    beforeDestroy() {
        clearTimeout(this.searchTimer);
    },
};
</script>

<style>
.notice-list__toolbar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 4px;
}
.notice-list__filters {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
}
.notice-list__actions {
    display: flex;
    gap: 8px;
}
.notice-list__filter-menu {
    width: 240px;
}
.notice-list__filter-options {
    display: flex;
    flex-wrap: wrap;
    column-gap: 16px;
    row-gap: 6px;
    padding-left: 8px;
}
.notice-list__filter-options .el-checkbox {
    margin-right: 0;
}
.notice-list__filter-reset {
    font-size: 13px;
}
/* lebar mengikuti search Client Management (±360px) */
.notice-list__search {
    width: 360px;
    max-width: 100%;
}
.input__notice__list .el-input__inner {
    padding-left: 30px;
    padding-right: 30px;
}
.button__add__notice__list {
    margin: 0px;
}
.notice-list__title {
    font-weight: 600;
    word-break: normal;
    overflow-wrap: anywhere;
}
.notice-list__dismissed {
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
}
.notice-list__delete {
    cursor: pointer;
}
.notice-list__help ul {
    padding-left: 20px;
    margin-bottom: 0;
}
/* modal bantuan selalu putih, sedangkan warna li mengikuti tema (pudar di tema gelap) */
.notice-list__help li {
    margin-bottom: 6px;
    color: #222a42;
}

@media (max-width: 575.98px) {
    .notice-list__filters,
    .notice-list__search,
    .notice-list__actions {
        width: 100%;
    }
    .notice-list__actions > *,
    .notice-list__actions .el-dropdown > span {
        flex: 1 1 0;
        display: block;
    }
    .button__add__notice__list {
        width: 100%;
    }
}
</style>
